<template>
    <div class="home">
        <div class="home__background">
            <picture>
                <slot name="picture"></slot>
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img class="o-fit"
                     v-bind:class="{ 'o-fit--contain' : fit === 'contain' || !fit, 'o-fit--cover' : fit === 'cover'  }"
                     src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" alt="" />
            </picture>
        </div>
        <div class="d-flex justify-content-center h-100">
<!--            <div class="a story-label text-uppercase">3D-Interaktiv</div>-->
            <div class="overflow-auto mask-image">
               <div class="block">
                    <div class="story-headline mb-4">
                        <slot name="headline"></slot>
                    </div>
<!--                    <div class="keyline-container position-relative my-1 py-1">-->
<!--                        <div class="keyline"></div>-->
<!--                    </div>-->
                    <div class="story-subline">
                        <slot name="subline"></slot>
                    </div>
                    <div class="story-text">
                        <slot name="text"></slot>
                    </div>
                    <div class="cta mt-4 ">
                        <LoadingProgress class="visible-babylon-loading"></LoadingProgress>
                        <div class="hidden-babylon-loading">
                            <router-link v-bind:to="$router.options.routes[1]" rel="next" class="btn btn--start" v-on-single-click="() => next()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                                    <path d="M36.9688 35L30.0417 41.9271C29.507 42.4618 29.2396 43.1307 29.2396 43.9337C29.2396 44.7368 29.507 45.429 30.0417 46.0104C30.625 46.5937 31.3182 46.8854 32.1213 46.8854C32.9243 46.8854 33.6166 46.5937 34.198 46.0104L43.1667 37.0416C43.75 36.4583 44.0417 35.7778 44.0417 35C44.0417 34.2222 43.75 33.5416 43.1667 32.9583L34.125 23.9166C33.5417 23.3333 32.8612 23.0543 32.0834 23.0796C31.3056 23.1048 30.625 23.4082 30.0417 23.9896C29.507 24.5729 29.227 25.2535 29.2017 26.0312C29.1764 26.809 29.4564 27.4896 30.0417 28.0729L36.9688 35ZM35 64.1666C30.9653 64.1666 27.1737 63.4005 23.625 61.8683C20.0764 60.3361 16.9896 58.2585 14.3646 55.6354C11.7396 53.0123 9.66199 49.9255 8.13171 46.375C6.60143 42.8244 5.83532 39.0328 5.83338 35C5.83143 30.9672 6.59754 27.1755 8.13171 23.625C9.66588 20.0744 11.7435 16.9876 14.3646 14.3646C16.9857 11.7415 20.0725 9.66387 23.625 8.13165C27.1775 6.59942 30.9692 5.83331 35 5.83331C39.0309 5.83331 42.8225 6.59942 46.375 8.13165C49.9275 9.66387 53.0144 11.7415 55.6355 14.3646C58.2566 16.9876 60.3352 20.0744 61.8713 23.625C63.4074 27.1755 64.1725 30.9672 64.1667 35C64.1609 39.0328 63.3948 42.8244 61.8684 46.375C60.342 49.9255 58.2644 53.0123 55.6355 55.6354C53.0066 58.2585 49.9198 60.3371 46.375 61.8712C42.8303 63.4054 39.0387 64.1705 35 64.1666ZM35 58.3333C41.5139 58.3333 47.0313 56.0729 51.5521 51.5521C56.073 47.0312 58.3334 41.5139 58.3334 35C58.3334 28.4861 56.073 22.9687 51.5521 18.4479C47.0313 13.9271 41.5139 11.6666 35 11.6666C28.4862 11.6666 22.9688 13.9271 18.448 18.4479C13.9271 22.9687 11.6667 28.4861 11.6667 35C11.6667 41.5139 13.9271 47.0312 18.448 51.5521C22.9688 56.0729 28.4862 58.3333 35 58.3333Z" fill="#00BBFF"/>
                                </svg>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="$config.branding === 'heute'" class="zdfheute-logo">
            <img class="img-fluid" src="../assets/img/zdfheute_logo.png" alt="">
        </div>

        <div v-if="$config.branding === 'logo'" class="zdflogo-logo">
            <img class="img-fluid" src="../assets/img/logo-Logo.png" alt="">
        </div>

        <div v-if="$config.branding === 'logo'" class="zdftivi-logo">
            <img class="img-fluid" src="../assets/img/ZDFtivi_Logo_weiss_600px.png" alt="">
        </div>


        <div class="story-update text-white text-right">
            <slot name="update"></slot>
        </div>
    </div>
</template>

<script>
    import LoadingProgress from "@/BabylonStory/components/LoadingProgress";

    export default {
        name: "Home",
        props: ['fit'],
        inject: ['$config'],
        components: {
            LoadingProgress
        },
        methods: {
            next: function () {
                this.$tracking.navigationClick(this.$router.options.routes[1], 'start');
                this.$eventBus.$emit('nextPage');
            }
        },
        mounted: function () {
            let box = document.querySelector('.mask-image');
            function watch() {
                let bool = (box.scrollHeight == (box.scrollTop + box.clientHeight));
                box.classList.toggle('scroll-end', bool);
            }
            box.addEventListener('scroll', watch);
        },
    }
</script>


<style scoped lang="scss">

</style>
